import * as types from "./types";

export const loginRequest = (payload: any) => ({
  type: types.LOGIN.request,
  payload,
});

export const logoutRequest = () => ({
  type: types.LOGOUT.request,
});
